// extracted by mini-css-extract-plugin
export var contentWrapper = "BentoCard-module--contentWrapper--9df8d";
export var description = "BentoCard-module--description--11ed4";
export var fadeInAnimation = "BentoCard-module--fadeInAnimation--36a32";
export var title = "BentoCard-module--title--8a21b";
export var wrapper = "BentoCard-module--wrapper--dd173";